import React from "react";
import IMG from "../../Assests/animation.gif"; // Your animation GIF
import { useNavigate } from "react-router-dom";
import "../order_success/order_success.css";

export default function OrderSuccess() {
  const navigate = useNavigate();

  return (
    <div className="success-container">
      <div className="success-card" style={{ backgroundImage: `url(${IMG})` }}>
        {/* Overlay is added via CSS ::before */}

        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="success-checkmark"
          viewBox="0 0 24 24"
          fill="green"
        >
          <path
            fillRule="evenodd"
            d="M10 15.172l7.071-7.071-1.414-1.414L10 12.344 7.343 9.686l-1.414 1.414L10 15.172z"
            clipRule="evenodd"
          />
        </svg>

        <h2 className="success-title">Thank you for ordering</h2>
        <p className="success-text">
          Your order has been placed successfully. 
        </p>

        <div className="success-button-group">
          <button
            className="success-button outline"
            onClick={() => navigate("/your_order")}
          >
            VIEW ORDERS
          </button>
          <button
            className="success-button solid"
            onClick={() => navigate("/")}
          >
            CONTINUE SHOPPING
          </button>
        </div>
      </div>
    </div>
  );
}
